<template>
  <div class="story-image-container">
    <div class="watch-on-tv">
      <div class="watch-on-tv__image">
        <img src="@/assets/img/tv.png" alt="watch on tv" />
      </div>
      <div class="watch-on-tv__video">
        <video
          src="https://assets.nflxext.com/ffe/siteui/acquisition/ourStory/fuji/desktop/video-tv-0819.m4v"
        ></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WatchOnTv",
};
</script>

<style lang="scss" scoped>
.watch-on-tv {
  overflow: hidden;
  position: relative;
  &__image {
    position: relative;
    z-index: 2;
    img {
      border: 0;
      height: auto;
      max-width: 100%;
    }
  }
  &__video {
    height: 100%;
    left: 50%;
    max-height: 54%;
    max-width: 73%;
    position: absolute;
    top: 46%;
    transform: translate(-50%, -50%);
    width: 100%;
    video {
      height: 100%;
      width: 100%;
    }
  }
}
</style>
